// TODO (CTRL-14): Replace this file with an API call to Acorn!!

type LogicalConnector = "AND" | "OR";
type LogicalOperator = "NOT";

type UnderstandingRepresentation = {
  name: string;
  question: string;
  line?: string;
  logicalOperator?: LogicalOperator;
  logicalConnective?: LogicalConnector;
  subConditions?: UnderstandingRepresentation[];
};

export const adultDepJSON: UnderstandingRepresentation = {
  line: "",
  question: "Can i qualify for the Adults dependant loan?",
  name: "CanGetAdultDependantsGrant",
  subConditions: [
    {
      line: "<p>If you’re a full-time student in higher education and an adult depends on you financially, you can apply for an Adult Dependants’ Grant of up to:</p>",
      question: "Are you a full-time student in higher education?",
      name: "YouAreFullTimeStudentInHigherEducation",
    },
    {
      line: "<p>You cannot get an Adult Dependants’ Grant if you’re getting a Postgraduate Loan.</p>",
      question: "Are you getting a Postgraduate Loan?",
      name: "GettingPostgraduateLoan",
      logicalOperator: "NOT",
    },
    {
      line: "<p>Usually the adult dependant will be:</p>",
      question: "Is your adult dependant eligible for the grant?",
      name: "AdultDependantIsEligibleForGrant",
      subConditions: [
        {
          line: "<li>your husband, wife, partner or civil partner</li>",
          question:
            "Is your adult dependant your husband, wife, partner or civil partner?",
          name: "AdultDependantIsYourHusbandWifePartnerOrCivilPartner",
        },
        {
          line: "<li>a relative, such as a parent or grandparent</li>",
          question:
            "Is your adult dependant a relative, such as a parent or grandparent?",
          name: "AdultDependantIsYourRelative",
        },
      ],
      logicalConnective: "OR",
    },
    {
      line: "<p>You’re not eligible if the adult dependant is:</p>",
      question: "Is your adult dependant ineligible for the grant?",
      name: "AdultDependantIsNotEligibleForGrant",
      logicalOperator: "NOT",
      subConditions: [
        {
          line: "<li>your child</li>",
          question: "Is your adult dependant your child?",
          name: "AdultDependantIsYourChild",
        },
        {
          line: "<li>a relative who earns more than £3,796 a year</li>",
          question:
            "Is your adult dependant a relative who earns more than £3,796 a year?",
          name: "AdultDependantIsRelativeWithHigherIncome",
        },
        {
          line: "<li>getting student finance</li>",
          question: "Is your adult dependant getting student finance?",
          name: "AdultDependantIsGettingStudentFinance",
        },
        {
          line: "<p>If you’re under 25, the adult dependant cannot be your partner unless you’re married or in a civil partnership.</p>",
          question:
            "Are you under 25 and the adult dependant is your partner that you are not married or in a civil relationship with?",
          name: "Under25AndAdultDependantIsPartnerNotMarriedOrInCivilRelationship",
        },
      ],
      logicalConnective: "OR",
    },
  ],
  logicalConnective: "AND",
};
